import React, { useRef } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  coin,
  profile,
  referralIcon,
  setting,
  topup,
  withdraw,
} from "@/constants";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { PopoverClose } from "@radix-ui/react-popover";
import Cookies from "js-cookie";
import useBalanceStore from "@/stores/user/balance.store";
import axios from "axios";
import { authApiURL } from "@/services/api.service";
import useDialogStore from "@/stores/loginDialog/store";
import useNavigationStore from "@/stores/navigation/store";
import WalletDialog from "@/pages/Wallet/Wallet";
import useUserStore from "@/stores/authentication/store";
import SharkDex from "@/pages/SharkDex/SharkDex";
import { getCdnUrl } from "@/lib/utils";

type Menu = {
  icon: string;
  title: string;
  url: string;
  loggedIn: boolean;
  value: string;
};

const menu: Menu[] = [
  {
    icon: profile as string,
    title: "Profile",
    url: "/profile",
    loggedIn: true,
    value: "account",
  },
  {
    icon: referralIcon as string,
    title: "Referrals",
    url: "/profile?tab=referrals",
    loggedIn: true,
    value: "referrals",
  },
  {
    icon: setting as string,
    title: "Settings",
    url: "/profile?tab=settings",
    loggedIn: true,
    value: "settings",
  },
  // {
  //   icon: blog,
  //   title: "Blog",
  //   url: "/",
  //   loggedIn: false,
  // },
  // {
  //   icon: article,
  //   title: "Article",
  //   url: "/",
  //   loggedIn: false,
  // },
  // {
  //   icon: helpCenter,
  //   title: "Help Center",
  //   url: "/",
  //   loggedIn: false,
  // },
  // {
  //   icon: cases,
  //   title: "Cases",
  //   url: "/",
  //   loggedIn: true,
  // },
  // {
  //   icon: support,
  //   title: "Support",
  //   url: "/",
  //   loggedIn: true,
  // },
  // {
  //   icon: faq,
  //   title: "FAQ",
  //   url: "/",
  //   loggedIn: true,
  // },
];

interface ProfileDropdownProps {
  trigger: React.ReactNode;
}

const ProfileDropdown = ({ trigger }: ProfileDropdownProps) => {
  const { balance, nativeBalance } = useBalanceStore();
  const { isAuthenticated, logout } = useUserStore();

  const setIsLoginSuccessDialogShown = useDialogStore(
    (state) => state.setIsLoginSuccessDialogShown,
  );

  // Filter menu items based on authentication status
  const filteredMenu = menu.filter((item) =>
    isAuthenticated ? true : !item.loggedIn,
  );

  const navigate = useNavigate();
  const setProfileActiveTab = useNavigationStore(
    (state) => state.setProfileActiveTab,
  );

  const closeRef = useRef<HTMLButtonElement>(null);

  const handleSignOut = async () => {
    handleClosePopover("profile");
    logout();
    setIsLoginSuccessDialogShown(false);
    navigate("/", { replace: true });
    Cookies.remove("jwtToken");
  };

  const handleClosePopover = (item: string) => {
    // Close the popover
    closeRef.current?.click();

    setProfileActiveTab(item);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        className={`${isAuthenticated ? "mt-2 md:mt-3" : "mt-5 md:mt-8"} max-h-[90vh] w-[300px] overflow-y-auto overflow-x-hidden border-[0.2px] border-white/10 bg-[#14142A] px-4 md:fixed md:right-[-30px]`}
      >
        <div className="ocean space-y-4">
          {/* top container - logged in */}
          {isAuthenticated && (
            <div className="space-y-3 rounded-lg bg-primary p-4">
              <div className="font-kanit text-sm font-bold text-white">
                Balance
              </div>

              <div className="flex items-center rounded-lg bg-white/5 p-2">
                <img
                  src={getCdnUrl("assets/icons/profile/sharkCoin100.svg")}
                  className="mr-2 h-[25px] w-[25px]"
                />
                <span className="font-inter text-[15px] font-semibold leading-[18px] text-white">
                  {nativeBalance?.toLocaleString()}
                </span>
              </div>

              <div className="flex items-center rounded-lg bg-white/5 p-2">
                <img
                  src={coin as string}
                  className="mr-2 size-[25px]"
                  alt={`coin`}
                />
                <span className="font-inter text-[15px] font-semibold leading-[18px] text-white">
                  {balance?.toLocaleString()}
                </span>
              </div>

              <div className="flex justify-between space-x-3">
                {/* top up */}
                <WalletDialog
                  trigger={
                    <div className="flex w-full cursor-pointer items-center rounded-lg bg-white/5 p-2">
                      <img
                        src={topup as string}
                        className="mr-2 size-[18px]"
                        alt={`topup`}
                      />
                      <span className="font-kanit text-sm font-medium text-white/50">
                        Deposit
                      </span>
                    </div>
                  }
                  initialActiveButton="deposit"
                />

                {/* withdraw */}
                <WalletDialog
                  trigger={
                    <div className="flex w-full cursor-pointer items-center rounded-lg bg-white/5 p-2">
                      <img
                        src={withdraw as string}
                        className="mr-2 size-[18px]"
                        alt={`withdraw`}
                      />
                      <span className="font-kanit text-sm font-medium text-white/50">
                        Withdraw
                      </span>
                    </div>
                  }
                  initialActiveButton="withdrawal"
                />
              </div>
            </div>
          )}

          <button className="relative h-[46px] w-full items-center rounded-lg bg-[url('/assets/profile/elightbg.png')] bg-cover lg:hidden ">
            <div className="flex items-center justify-center gap-2 text-center ">
              <img
                className="h-6 w-[25.33px]"
                src="/assets/main/vip-crown.png"
                alt={"vip-crown"}
              />
              <div className="font-['Ubuntu'] text-[15px] font-medium leading-[18px] text-white">
                Elite Gamers Club
              </div>
            </div>
          </button>

          {/* menu items */}
          {filteredMenu.map((item, index) => (
            <Link
              to={item.url}
              key={index}
              className="flex w-full cursor-pointer items-center rounded-lg bg-white/5 px-4 py-2 hover:bg-[#1E2DB8]"
              onClick={() => handleClosePopover(item.value)}
            >
              <img
                src={item.icon}
                alt="icon"
                className="mr-4 max-h-[18px] w-[18px]"
              />
              <span className="font-kanit text-sm font-medium text-white/50">
                {item.title}
              </span>
            </Link>
          ))}

          {/* bottom container - logged in */}

          {isAuthenticated && (
            <>
              {/*-- Select Language */}
              {/*<Select*/}
              {/*  value={selectdLanguage}*/}
              {/*  onValueChange={setSelectedLanguage}*/}
              {/*>*/}
              {/*  <SelectTrigger className="w-full border-0 bg-white/5 text-white">*/}
              {/*    <SelectValue className="font-kanit text-sm font-bold" />*/}
              {/*  </SelectTrigger>*/}
              {/*  <SelectContent>*/}
              {/*    <SelectGroup>*/}
              {/*      {languages.map((language, index) => (*/}
              {/*        <SelectItem key={index} value={language.value}>*/}
              {/*          <div className="flex items-center">*/}
              {/*            <img src={language.icon} className="mr-4" />*/}
              {/*            <span className="font-kanit text-sm font-bold">*/}
              {/*              {language.label}*/}
              {/*            </span>*/}
              {/*          </div>*/}
              {/*        </SelectItem>*/}
              {/*      ))}*/}
              {/*    </SelectGroup>*/}
              {/*  </SelectContent>*/}
              {/*</Select>*/}

              <Button
                variant="gradient"
                className="w-full font-kanit text-sm font-bold"
                onClick={handleSignOut}
              >
                Sign Out
              </Button>
            </>
          )}
        </div>
        <PopoverClose className="hidden" ref={closeRef} />
      </PopoverContent>
    </Popover>
  );
};

export default ProfileDropdown;
